import PartnerAdminsPage from '@playground/features/partner-admins/PartnerAdminsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_superAdmin/partner-admins')({
  component: PartnerAdminsPage,
})
